import { LaneHistoryTable } from "../../../dispatch/src/LaneHistoryTable";
import { QuoteRates } from "../../../dispatch/src/QuoteRates";
import { RateIndexDataSummary } from "../../../dispatch/src/RateIndexDataSummary";
import { QuoteLanding } from "../QuoteLanding";
import { QuoteStopTable } from "../QuoteStopTable";
import { Button, CityState, DataHeader, DataSource, Image, Label, Layout, Panel, SaveButton, SearchPanel, Step, Stepper, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutQuickQuote extends Layout {
    buttonContinue: Button;
    buttonSave: SaveButton;
    citystateConsigneeCS: CityState;
    citystateShipperCS: CityState;
    citystateStopOriginCityId: CityState;
    dataheaderQuote: DataHeader;
    imageHazmat: Image;
    labelAdditionalInformation: Label;
    labelCaptionContactSuggestedPricing: Label;
    labelCaptionCustomerSuggestedPricing: Label;
    labelContactEmailSuggestedPricing: Label;
    labelContactNameSuggestedPricing: Label;
    labelContactPhoneSuggestedPricing: Label;
    labelCustomerNameSuggestedPricing: Label;
    labelDeliveryCaption: Label;
    labelHazmatCommodity: Label;
    labelPickupCaption: Label;
    labelPickupandDeliveries: Label;
    layoutLaneHistory: LaneHistoryTable;
    layoutQuoteLanding: QuoteLanding;
    layoutQuoteRates: QuoteRates;
    layoutQuoteStopTable: QuoteStopTable;
    layoutRateIndex: RateIndexDataSummary;
    panelCommodityHazmat: Panel;
    panelConsignee: Panel;
    panelContainerSuggestedPricing: Panel;
    panelCustomer: Panel;
    panelCustomerContact: Panel;
    panelCustomerContainer: Panel;
    panelCustomerSuggestedPricing: Panel;
    panelOrderFields: Panel;
    panelPickupandDeliveries: Panel;
    panelPricingContent: Panel;
    panelQuoteFieldContainer: Panel;
    panelQuoteOrderFields: Panel;
    panelRow1SuggestedPricing: Panel;
    panelShipperSuggestedPricing: Panel;
    panelStepTwoCommodity: Panel;
    panelSuggestedPricingOverview: Panel;
    searchpanelLaneHistoryFilter: SearchPanel;
    sourceLaneHistory: DataSource;
    sourceQuoteOrder: DataSource;
    sourceQuoteStop: DataSource;
    sourceRateIndexControl: DataSource;
    stepEntry: Step;
    stepNextActions: Step;
    stepSuggestedPricing: Step;
    stepperQuickQuote: Stepper;
    tabLaneHistory: Tab;
    tabRateIndex: Tab;
    tabsetSuggestedPricing: Tabset;
    textboxCommodity: Textbox;
    textboxCommodityId: Textbox;
    textboxCustomerContactName: Textbox;
    textboxCustomerEmail: Textbox;
    textboxCustomerName: Textbox;
    textboxCustomerPhone: Textbox;
    textboxDateRange: Textbox;
    textboxDistanceSuggestedPricing: Textbox;
    textboxEquipmentTypeId: Textbox;
    textboxMovementStatus: Textbox;
    textboxNotes: Textbox;
    textboxOrderLength: Textbox;
    textboxRadius: Textbox;
    textboxStepTwoCommodityId: Textbox;
    textboxTotalCharge: Textbox;
    textboxTrailerTypeReviewSuggestedPricing: Textbox;
    textboxWeight: Textbox;
    textboxWeightSuggestedPricing: Textbox;
}
